import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: [],
    provinceList: [],
    provincesByIdList: [],
    countryList: [],
    provinceOfTadbirList: [],
    cityList: [],
    cityOfTadbirList: [],
    details: []
  },
  getters: {
    list: state => state.list,
    provinceList: state => state.provinceList,
    countryList: state => state.countryList,
    provincesByIdList: state => state.provincesByIdList,
    provinceOfTadbirList: state => state.provinceOfTadbirList,
    cityList: state => state.cityList,
    cityOfTadbirList: state => state.cityOfTadbirList,
    details: state => state.details
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get("Geography/api/CountriesQuery/type/1").then(r => {
        commit("setList", r.data);
      });
    },
    fetchCountry({ commit, dispatch }) {
      return ajax.get("Geography/api/CountriesQuery/countries").then(r => {
      });
    },

    fetchNoSkip({ commit, dispatch }) {
      return ajax
        .get("Geography/api/CountriesQuery?Take=5000&Skip=0")
        .then(r => {
          commit("setList", r.data.data);
        });
    },
    fetchProvinces({ commit, dispatch }) {
      return ajax.get("Geography/api/CountriesQuery/2").then(r => {
        commit("setProvinceList", r.data);
      });
    },
    fetchProvincesByIdSupplier({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get(`Geography/api/CountriesQuery/provinces/${id}`)
          .then(r => {
            commit("setProvinceList", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    fetchCountry({ commit, dispatch } ) {
      return ajax.get(`Geography/api/CountriesQuery/Allcountries`).then(r => {
        commit("setCountryList", r.data);

      });
    },
    fetchProvincesById({ commit, dispatch } , id) {
      return new Promise((resolve, reject) => {
        ajax
          .get(`Geography/api/CountriesQuery/provinces/${id}`)
          .then(r => {
            commit("setProvincesByIdList", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    fetchProvincesOfTadbir({ commit, dispatch }) {
      return ajax
        .get("BusinessParties/api/PartiesQuery/all-tadbir-provinces")
        .then(r => {
          commit("setProvinceOfTadbirList", r.data);
        });
    },
    fetchCitiesById({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Geography/api/CitesQuery?parentId=" + id)
          .then(r => {
            commit("setCityList", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    fetchCitiesOfTadbirById({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("BusinessParties/api/PartiesQuery/all-tadbir-cities/" + id)
          .then(r => {
            commit("setCityOfTadbirList", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    fetchById({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Geography/api/CountriesQuery/0/" + id)
          .then(r => {
            commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    create({ commit, dispatch }, model) {
      return ajax.post("Geography/api/Countries/country", model).then(r => {
        dispatch("fetch");
      });
    },
    createProvince({ commit, dispatch }, model) {
      return ajax.post("Geography/api/Countries/province", model).then(r => {
        // dispatch("fetch");
      });
    },
    modifyProvince({ commit, dispatch }, model) {
      return ajax.put("Geography/api/Countries/province", model).then(r => {
        // dispatch("fetch");
      });
    },
    createCity({ commit, dispatch }, model) {
      return ajax.post("Geography/api/Countries/city", model).then(r => {
        // dispatch("fetch");
      });
    },
    modifyCity({ commit, dispatch }, model) {
      return ajax.put("Geography/api/Countries/city", model).then(r => {
        // dispatch("fetch");
      });
    },
    modifyCountry({ commit, dispatch }, model) {
      return ajax.put("Geography/api/Countries/country", model).then(r => {
        // dispatch("fetch");
      });
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "Geography/api/Countries/country",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(r => {
          dispatch("fetch");
        });
    },
    removeProvince({ commit, dispatch }, id) {
      return ajax
        .delete(
          "Geography/api/Countries/province",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(r => {
          dispatch("fetch");
        });
    },
    removeCity({ commit, dispatch }, id) {
      return ajax
        .delete(
          "Geography/api/Countries/city",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(r => {
          dispatch("fetch");
        });
    },
    update({ commit, dispatch }, model) {
      return ajax.put("Geography/api/Countries", model).then(r => {
        dispatch("fetch");
      });
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
    setProvinceList(state, data) {
      state.provinceList = data;
    },
    setCountryList(state, data) {
      state.countryList = data;
    },
    setProvincesByIdList(state, data) {
      state.provincesByIdList = data;
    },
    setProvinceOfTadbirList(state, data) {
      state.provinceOfTadbirList = data;
    },
    setCityList(state, data) {
      state.cityList = data;
    },
    setCityOfTadbirList(state, data) {
      state.cityOfTadbirList = data;
    },
    setDetails(state, data) {
      state.details = data;
    }
  }
};
